
import {MoveTo_Manager} from "../../move-to/model/manager"
import ApiProject from "../../../gd/api/project"
import {MoveTo_CurrentStep} from "../../move-to/@const"

// const debug = "AddProject_Manager"
const debug = false

export class AddToProject_Manager extends MoveTo_Manager {

    public callback?: callback

    get modalTitle():string {
        return "Add task to project"
    }

    get isTargetProjectAvailable() {
        const taskToMove    = this.tasksToMove[0]

        if (!this.targetProject || taskToMove.isInProject(this.targetProject.id)) {
            return false
        }

        return true
    }

    validateUsers = async () => {
        // No user validation is required on add (link) project to task
        debug && console.log(debug, 'validateUsers: skip this step', this)
        this.setCurrentStep(MoveTo_CurrentStep.MOVING)
        this.commitMove()
    }

    commitMove = async () => {
        debug && console.log(debug, 'commitMove')

        const taskToMove    = this.tasksToMove[0]
        const targetProject = this.targetProject!

        await ApiProject.addTasks(targetProject.id, [taskToMove.id]).promise()

        debug && console.log(debug, 'commitMove callback', this.callback)

        this.callback?.(targetProject)
        gd.modal.hide()
    }

    commit() {
        this.commitMove()
    }
}